/**
 * PaymentMethod type matching the CMS API response.
 * Populated at runtime via usePaymentMethods() hook.
 * GET /rest/api/web/cms/payment-methods
 */
export interface PaymentMethod {
  id: number;
  code: string;
  legacyCode: number;
  name: string;
  type: string;
}

export const CHECKOUT_TIMEOUT = 600;

export const PAYPHONE_SDK_JS =
  "https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.js";
export const PAYPHONE_SDK_CSS =
  "https://cdn.payphonetodoesposible.com/box/v1.1/payphone-payment-box.css";
